import styles from "./PaymentWelcome.module.scss";
import { Dispatch, FC, SetStateAction } from "react";
import { Plan } from "@/models/subscription";
import dayjs from "dayjs";
import RocketIcon from "@mui/icons-material/Rocket";
import { Box, Button, Card, Typography } from "@mui/material";
import useWelcomeDestination from "src/hooks/useWelcomeDestination";

interface PropsTypes {
    plan: Plan;
    closeModal: Dispatch<SetStateAction<boolean>>;
}

const PaymentWelcome: FC<PropsTypes> = ({ closeModal, plan }) => {
    // The page the ad brought them to (short interest for one ticker, insider trades, ...);
    // the markets overview when nothing is known. The same link is in the welcome email.
    const destination = useWelcomeDestination();
    const onClick = () => {
        closeModal(false);
        window.location.href = `${window.location.origin}${destination.path}`;
    };

    return (
        <Box className={styles.PaymentWelcome}>
            <Card className={styles.card} elevation={0}>
                <RocketIcon sx={{ fontSize: "90px" }} color={"primary"} />
                <Typography component="h1" variant="h1">
                    Welcome to ORTEX
                </Typography>
                <Typography variant="h2">
                    Your {plan.product_name} subscription has begun as of {dayjs().format("DD/MM/YYYY")}
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    A welcome email with your login details and this link is on its way.
                </Typography>
            </Card>
            <Button className={styles.btn} variant="contained" onClick={onClick} sx={{ textTransform: "initial" }}>
                Open {destination.label}
            </Button>
        </Box>
    );
};

export default PaymentWelcome;
